import { PeriodEnum, OverviewTypeTimeEnum } from "./PeriodEnum.js";

export const formatDateTimeString = (value) => {
  if (!value) return "";
  let date = new Date(value);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return `${dt}/${month}/${year}`;
};

export const formatDateTimeString2 = (value) => {
  if (!value) return "";
  let date = new Date(value);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  let time = `${dt}/${month}/${year} ${hours}:${minutes}`;
  if (hours > 12) {
    hours = hours - 12;
    time = `${dt}/${month}/${year} ${hours}:${minutes}`;
    time = time + " PM";
  } else {
    time = time + " AM";
  }
  return time;
};

export const formatDateTimeString3 = (value) => {
  let date = new Date(value);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();
  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return `${year}-${month}-${dt}`;
};
/**
 * Hàm chuyển từ datetime sang tháng / năm
 * @param {} value
 * @returns
 * LTHAI(6/3/2021)
 */
export const formatDateTimeString4 = (value) => {
  if (value == "") {
    return "";
  }
  let date = new Date(value);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  return `Tháng ${month}/${year}`;
};
/**
 * Hàm lấy khoảng thời gian theo enum truyền vào
 * @param {*} period
 */
export const convertReportPeriod = (period) => {
  let result = {
    FromDate: null,
    ToDate: null,
  };
  if (period) {
    switch (period) {
      case PeriodEnum.ToDay:
        result.FromDate = moment().startOf("day").toDate();
        result.ToDate = moment().endOf("day").toDate();
        break;
      case PeriodEnum.ThisWeek:
        result.FromDate = moment().startOf("isoweek").toDate();
        result.ToDate = moment().endOf("isoweek").toDate();
        break;
      case PeriodEnum.ThisMonth:
        result.FromDate = moment().startOf("month").toDate();
        result.ToDate = moment().endOf("month").toDate();
        break;
      case PeriodEnum.ThisQuarter:
        result.FromDate = moment().startOf("quarter").toDate();
        result.ToDate = moment().endOf("quarter").toDate();
        break;
      case PeriodEnum.ThisYear:
        result.FromDate = moment().startOf("year").toDate();
        result.ToDate = moment().endOf("year").toDate();
        break;
      case PeriodEnum.LastDay:
        result.FromDate = moment().subtract(1, "day").startOf("day").toDate();
        result.ToDate = moment().subtract(1, "day").endOf("day").toDate();
        break;
      case PeriodEnum.LastWeek:
        result.FromDate = moment()
          .subtract(1, "week")
          .startOf("isoweek")
          .toDate();
        result.ToDate = moment().subtract(1, "week").endOf("isoweek").toDate();
        break;
      case PeriodEnum.LastMonth:
        result.FromDate = moment()
          .subtract(1, "month")
          .startOf("month")
          .toDate();
        result.ToDate = moment().subtract(1, "month").endOf("month").toDate();
        break;
      case PeriodEnum.LastQuarter:
        result.FromDate = moment()
          .subtract(1, "quarter")
          .startOf("quarter")
          .toDate();
        result.ToDate = moment()
          .subtract(1, "quarter")
          .endOf("quarter")
          .toDate();
        break;
      case PeriodEnum.LastYear:
        result.FromDate = moment().subtract(1, "year").startOf("year").toDate();
        result.ToDate = moment().subtract(1, "year").endOf("year").toDate();
        break;
      case PeriodEnum.FistSixMonths:
        let startYear = moment().startOf("year").toDate();
        result.FromDate = startYear;
        let temp = moment(startYear).add(6, "M").toDate();
        result.ToDate = moment(temp).subtract(1, "second").toDate();
        break;
      case PeriodEnum.LastSixMonths:
        let startYearNow = moment().startOf("year").toDate();
        result.FromDate = moment(startYearNow).add(6, "M").toDate();
        let tempNow = moment().add(1, "year").startOf("year").toDate();
        result.ToDate = moment(tempNow).subtract(1, "second").toDate();
        break;
      case PeriodEnum.FourWeekAgo:
        result.FromDate = moment()
          .subtract(3, "week")
          .startOf("isoweek")
          .toDate();
        result.ToDate = moment().endOf("isoweek").toDate();
        break;
      case PeriodEnum.ThisMonthVerWeek:
        let startMonth = moment().startOf("month").toDate();
        result.FromDate = moment(startMonth).startOf("isoweek").toDate();
        let endMonth = moment().endOf("month").toDate();
        result.ToDate = moment(endMonth).endOf("isoweek").toDate();
        break;
      case PeriodEnum.LastMonthVerWeek:
        let startLastMonth = moment()
          .subtract(1, "month")
          .startOf("month")
          .toDate();
        result.FromDate = moment(startLastMonth).startOf("isoweek").toDate();
        let endLastMonth = moment()
          .subtract(1, "month")
          .endOf("month")
          .toDate();
        result.ToDate = moment(endLastMonth).endOf("isoweek").toDate();
        break;
      case PeriodEnum.Tomorrow:
        result.FromDate = moment().add(1, "day").startOf("day").toDate();
        result.ToDate = moment().add(1, "day").endOf("day").toDate();
        break;
      case PeriodEnum.NextWeek:
        result.FromDate = moment().add(1, "week").startOf("isoweek").toDate();
        result.ToDate = moment().add(1, "week").endOf("isoweek").toDate();
        break;
      case PeriodEnum.ThisMonthVerWeek:
        let startMonthVWeek = moment().startOf("month").toDate();
        result.FromDate = moment(startMonthVWeek).startOf("isoweek").toDate();
        let endMonthVWeek = moment().endOf("month").toDate();
        result.ToDate = moment(endMonthVWeek).endOf("isoweek").toDate();
        break;
      case PeriodEnum.LastMonthVerWeek:
        let startLastMonthVWeek = moment()
          .subtract(1, "month")
          .startOf("month")
          .toDate();
        result.FromDate = moment(startLastMonthVWeek)
          .startOf("isoweek")
          .toDate();
        let endLastMonthVWeek = moment()
          .subtract(1, "month")
          .endOf("month")
          .toDate();
        result.ToDate = moment(endLastMonthVWeek).endOf("isoweek").toDate();
        break;
      case PeriodEnum.OptionDate:
        result.FromDate = null;
        result.ToDate = null;
        break;
    }
    return result;
  }
};

/**
 * Hàm lấy thời gian FromDate và ToDate
 * @param {*} dataTime Kiểu thống kê theo (tháng, quý, năm)
 * @param {*} yearOrTotalYear Năm hoặc tổng số năm thống kê-TH thống kê theo năm
 */
export const convertReportTime = (dataTime, yearOrTotalYear) => {
  if (dataTime == 0) return;
  let currentYear = new Date().getFullYear();
  let result = {
    FromDate: null,
    ToDate: null,
  };
  if (dataTime == OverviewTypeTimeEnum.Year) {
    result.FromDate = moment()
      .set("year", currentYear - yearOrTotalYear + 1)
      .startOf("year")
      .toDate();
    result.ToDate = moment().set("year", currentYear).endOf("year").toDate();
  } else {
    result.FromDate = moment()
      .set("year", yearOrTotalYear)
      .startOf("year")
      .toDate();
    result.ToDate = moment()
      .set("year", yearOrTotalYear)
      .endOf("year")
      .toDate();
  }
  return result;
};

/**
 * Hàm lấy ngày đầu tháng và ngày cuối tháng
 * @param {*} date Ngày trong tháng
 * @returns
 */
export const getStartAndEndMonth = (date) => {
  let month = date.getMonth();
  let result = {};
  result.StartOfMonth = moment().set("month", month).startOf("month").toDate();
  result.EndOfMonth = moment().set("month", month).endOf("month").toDate();
  return result;
};
